/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OrderConstants = {
    ASCENDING: 'ASCENDING',
    DESCENDING: 'DESCENDING'
} as const;
export type OrderConstants = typeof OrderConstants[keyof typeof OrderConstants];


export function OrderConstantsFromJSON(json: any): OrderConstants {
    return OrderConstantsFromJSONTyped(json, false);
}

export function OrderConstantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderConstants {
    return json as OrderConstants;
}

export function OrderConstantsToJSON(value?: OrderConstants | null): any {
    return value as any;
}

